/**
 * Tisha — UGC Review submission + display
 *
 * On PDP load:
 *   - Wires "Write a review" button(s) to open form modal
 *   - Star rating picker
 *   - Form submits to /api/submit-review
 *   - Success message + 10s auto-close
 *   - Fetches approved reviews from /api/get-reviews and renders into [data-tp-real-reviews]
 *   - Updates aggregate rating display [data-tp-aggregate-rating], [data-tp-review-count]
 *
 * Endpoints (Vercel project tisha-tag-api):
 *   POST https://tisha-tag-api.vercel.app/api/submit-review
 *   GET  https://tisha-tag-api.vercel.app/api/get-reviews?product_id=NN
 */
(function(){
  var SUBMIT_URL = 'https://tisha-tag-api.vercel.app/api/submit-review';
  var GET_URL    = 'https://tisha-tag-api.vercel.app/api/get-reviews';

  /* ── Modal open/close (reusing tp-b2b-modal styles) ───────────── */
  function openModal(modal){
    if(!modal) return;
    modal.classList.remove('is-hidden');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('overflow-hidden');
    document.body.style.overflow='hidden';
  }
  function closeModal(modal){
    if(!modal) return;
    modal.classList.add('is-hidden');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow='';
  }
  document.querySelectorAll('[data-tp-review-open]').forEach(function(btn){
    var id = btn.getAttribute('aria-controls');
    var modal = document.getElementById(id);
    btn.addEventListener('click', function(e){ e.preventDefault(); openModal(modal); });
  });

  /* Auto-open modal if URL hash is #write-review (for Mailchimp email links) */
  function maybeOpenFromHash(){
    if(window.location.hash !== '#write-review' && window.location.hash !== '#leave-review') return;
    var modal = document.querySelector('[data-tp-review-modal]');
    if(modal){
      openModal(modal);
      /* Scroll body so modal feels intentional */
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', maybeOpenFromHash);
  } else {
    setTimeout(maybeOpenFromHash, 100);
  }
  window.addEventListener('hashchange', maybeOpenFromHash);
  document.querySelectorAll('[data-tp-review-modal] [data-tp-review-close]').forEach(function(btn){
    btn.addEventListener('click', function(){ closeModal(btn.closest('[data-tp-review-modal]')); });
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var open = document.querySelector('[data-tp-review-modal]:not(.is-hidden)');
    if(open) closeModal(open);
  });

  /* ── Star picker ──────────────────────────────────────────────── */
  document.querySelectorAll('[data-tp-review-stars]').forEach(function(group){
    var stars = group.querySelectorAll('.tp-review-star');
    var hidden = group.querySelector('[data-tp-review-rating-input]');
    var current = 0;
    function paint(n){
      stars.forEach(function(s, i){
        if(i < n){ s.classList.add('is-active'); s.setAttribute('aria-checked', 'true'); }
        else     { s.classList.remove('is-active'); s.setAttribute('aria-checked', 'false'); }
      });
    }
    stars.forEach(function(s, i){
      var n = i + 1;
      s.addEventListener('mouseenter', function(){ paint(n); });
      s.addEventListener('mouseleave', function(){ paint(current); });
      s.addEventListener('click', function(){ current = n; hidden.value = String(n); paint(n); });
    });
  });

  /* ── Form submission ──────────────────────────────────────────── */
  document.querySelectorAll('[data-tp-review-form]').forEach(function(form){
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      var errBox = form.querySelector('[data-tp-review-error]');
      var fieldsBox = form.querySelector('[data-tp-review-fields]');
      var successBox = form.querySelector('[data-tp-review-success]');
      var submitBtn = form.querySelector('[data-tp-review-submit]');
      errBox.hidden = true; errBox.textContent = '';

      var fd = new FormData(form);
      var rating = parseInt(fd.get('rating') || '0', 10);
      if(!(rating >= 1 && rating <= 5)){
        errBox.textContent = 'Please select a star rating.';
        errBox.hidden = false;
        return;
      }

      var url = new URL(window.location.href);
      var qs = url.searchParams;

      var payload = {
        hp: fd.get('hp') || '',
        product_id: form.dataset.productId,
        product_handle: form.dataset.productHandle,
        product_title: form.dataset.productTitle,
        rating: rating,
        title: fd.get('title') || '',
        body: fd.get('body') || '',
        reviewer_name: fd.get('reviewer_name') || '',
        reviewer_email: fd.get('reviewer_email') || '',
        reviewer_role: fd.get('reviewer_role') || '',
        page_url: window.location.href,
        utm_source: qs.get('utm_source') || '',
        utm_medium: qs.get('utm_medium') || '',
        utm_campaign: qs.get('utm_campaign') || '',
        gclid: qs.get('gclid') || '',
        order_id: qs.get('order_id') || '',
        order_token: qs.get('order_token') || '',
      };

      submitBtn.disabled = true;
      var origLabel = submitBtn.textContent;
      submitBtn.textContent = 'Submitting…';

      try {
        var r = await fetch(SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        var data = await r.json().catch(function(){ return {}; });
        if(r.ok && data.ok){
          fieldsBox.hidden = true;
          successBox.hidden = false;
          var modal = form.closest('[data-tp-review-modal]');
          var countdown = successBox.querySelector('[data-tp-review-countdown]');
          var seconds = 10;
          var t = setInterval(function(){
            seconds -= 1;
            if(countdown) countdown.textContent = seconds;
            if(seconds <= 0){ clearInterval(t); closeModal(modal); }
          }, 1000);
          /* Track in dataLayer if present */
          if(window.dataLayer) window.dataLayer.push({ event: 'review_submitted', rating: rating, product_id: payload.product_id });
        } else {
          errBox.textContent = data.error === 'spam_check_failed'
            ? 'Spam check failed. Please refresh the page and try again.'
            : (data.error === 'missing_or_invalid_fields' ? 'Please complete all required fields.' : 'Something went wrong. Please try again or email info@tishahygiene.co.uk.');
          errBox.hidden = false;
        }
      } catch (err) {
        errBox.textContent = 'Network error. Please try again.';
        errBox.hidden = false;
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = origLabel;
      }
    });
  });

  /* ── Display approved reviews on PDP ──────────────────────────── */
  var realContainer = document.querySelector('[data-tp-real-reviews]');
  if(realContainer){
    var productId = realContainer.getAttribute('data-product-id');
    if(productId){
      fetch(GET_URL + '?product_id=' + encodeURIComponent(productId))
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(data){
          if(!data || !data.ok) return;
          renderReviews(realContainer, data);
          updateAggregate(data);
        })
        .catch(function(){});
    }
  }

  function renderReviews(container, data){
    if(!data.reviews || data.reviews.length === 0) return;
    /* Detect which grid style: paper PDPs use `.tp-reviews-grid`, hardware use `.th-reviews__grid` */
    var isPaperStyle = container.classList.contains('tp-reviews-grid');

    var html = data.reviews.map(function(rev){
      var dateLabel = relativeDate(rev.date);
      if(isPaperStyle){
        var stars = '';
        for(var i = 1; i <= 5; i++){ stars += (i <= rev.rating) ? '★' : '☆'; }
        return ''
          + '<div class="tp-review-card" data-tp-review-card>'
          +   '<div class="tp-review-stars">' + stars + '</div>'
          +   '<div class="tp-review-title">' + escapeHtml(rev.title) + '</div>'
          +   '<div class="tp-review-text">"' + escapeHtml(rev.body).replace(/\n/g, '<br>') + '"</div>'
          +   '<div class="tp-review-author">'
          +     '<span class="tp-review-name">' + escapeHtml(rev.reviewer_name) + '</span>'
          +     (rev.reviewer_role ? '<span class="tp-review-role">' + escapeHtml(rev.reviewer_role) + '</span>' : '')
          +   '</div>'
          +   '<div class="tp-review-meta">'
          +     (rev.verified ? '<span class="tp-review-verified">Verified Buyer</span>' : '')
          +     '<span class="tp-review-date">' + dateLabel + '</span>'
          +   '</div>'
          + '</div>';
      }
      /* Hardware style — th-review HTML matching static blocks */
      var starsSvg = '';
      for(var j = 1; j <= 5; j++){
        if(j <= rev.rating){
          starsSvg += '<svg width="13" height="13" viewBox="0 0 20 20" fill="#C9A84C" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
        } else {
          starsSvg += '<svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="#C9A84C" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
        }
      }
      return ''
        + '<div class="th-review" data-tp-review-card>'
        +   '<div class="th-review__stars">' + starsSvg + '</div>'
        +   '<div class="th-review__title">' + escapeHtml(rev.title) + '</div>'
        +   '<div class="th-review__text">"' + escapeHtml(rev.body).replace(/\n/g, '<br>') + '"</div>'
        +   '<div class="th-review__author">'
        +     '<span class="th-review__name">' + escapeHtml(rev.reviewer_name) + '</span>'
        +     (rev.reviewer_role ? '<span class="th-review__role">' + escapeHtml(rev.reviewer_role) + '</span>' : '')
        +   '</div>'
        +   '<div class="th-review__meta">'
        +     (rev.verified ? '<span class="th-review__verified">&#10003; Verified purchase</span>' : '')
        +     '<span class="th-review__date">' + dateLabel + '</span>'
        +   '</div>'
        + '</div>';
    }).join('');
    container.insertAdjacentHTML('afterbegin', html);
    applyShowMore(container);
  }

  function relativeDate(iso){
    if(!iso) return 'recently';
    var d = new Date(iso);
    if(isNaN(d.getTime())) return 'recently';
    var diff = Math.floor((Date.now() - d.getTime()) / 86400000);
    if(diff <= 0) return 'today';
    if(diff === 1) return '1 day ago';
    if(diff < 30) return diff + ' days ago';
    if(diff < 60) return '1 month ago';
    if(diff < 365) return Math.floor(diff / 30) + ' months ago';
    return d.toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' });
  }

  /* Show first N cards, hide rest until "Show all N reviews" clicked
     N depends on grid layout: paper (3-col) → 3, hardware (2-col) → 2 */
  function applyShowMore(container){
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-tp-review-card]'));
    var defaultLimit = container.classList.contains('th-reviews__grid') ? 2 : 3;
    if(cards.length <= defaultLimit) return;
    cards.forEach(function(c, i){ if(i >= defaultLimit) c.setAttribute('data-tp-hidden','1'); });
    /* Find the wrap element next to the grid */
    var wrap = container.parentElement.querySelector('[data-tp-show-more-wrap]');
    if(!wrap) return;
    wrap.removeAttribute('hidden');
    var btn = wrap.querySelector('[data-tp-show-more-btn]');
    var countSpan = wrap.querySelector('[data-tp-show-more-count]');
    if(countSpan) countSpan.textContent = cards.length;
    if(btn && !btn.dataset.tpBound){
      btn.dataset.tpBound = '1';
      btn.addEventListener('click', function(){
        cards.forEach(function(c){ c.removeAttribute('data-tp-hidden'); });
        wrap.setAttribute('hidden', '');
      });
    }
  }
  /* Apply show-more on initial page load to static block reviews too */
  document.querySelectorAll('[data-tp-show-more-grid]').forEach(applyShowMore);

  function updateAggregate(data){
    /* Update star bar at top of PDP if real reviews present */
    var avgEl = document.querySelector('[data-tp-aggregate-rating]');
    var countEl = document.querySelector('[data-tp-review-count]');
    if(!data.count) return;
    /* Агрегат — лише з реальних відгуків API (статичних більше немає, ТЗ Ольги 05.10.2026) */
    var combined = data.average;
    var combinedCount = data.count;
    if(avgEl) avgEl.textContent = (Math.round(combined * 10) / 10).toFixed(1);
    if(countEl) countEl.textContent = combinedCount;
    /* Also update inline rating count in hero card */
    var heroCount = document.querySelector('.th-rating__count');
    if(heroCount){
      heroCount.firstChild.textContent = '(' + combinedCount + ') ';
    }
  }

  function escapeHtml(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }
})();
